import axios from 'axios'

const state = {
    legal_entity: {},
    legal_entities: {},
    legal_entity_errors: {},
    legal_entity_loading: false,
}

const getters = {
    legal_entity: state => state.legal_entity,
    legal_entities: state => state.legal_entities,
    legal_entity_errors: state => state.legal_entity_errors,
    legal_entity_loading: state => state.legal_entity_loading,
}

const mutations = {
    setLegalEntity(state, legal_entity) {
        state.legal_entity = legal_entity
    },
    setLegalEntities(state, legal_entities) {
        state.legal_entities = legal_entities
    },
    setLegalEntityErrors(state, legal_entity_errors) {
        state.legal_entity_errors = legal_entity_errors
    },
    setLegalEntityLoading(state, legal_entity_loading) {
        state.legal_entity_loading = legal_entity_loading
    },
}

const actions = {
    async updateLegalEntity({commit}, data) {
        commit('setLegalEntityLoading', true)
        commit('setLegalEntityErrors', {})
        try {
            let response = await axios.put(`/api/admin/entities/legal/${data.id}/update`,data)
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getLegalEntity({commit}, id) {
        commit('setLegalEntityLoading', true)
        commit('setLegalEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/legal/${id}/show`)
            commit('setLegalEntity', response.data.data)
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', error.response.data.errors)
            return false
        }
    },
    async getLegalEntities({commit}, data) {
        commit('setLegalEntityLoading', true)
        commit('setLegalEntityErrors', {})
        try {
            let response = await axios.get(`/api/admin/entities/legal`,data)
            commit('setLegalEntities', response.data)
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setLegalEntityLoading', false)
            commit('setLegalEntityErrors', error.response.data.errors)
            return false
        }
    },


}

export default {
    state,
    getters,
    mutations,
    actions
}